import React from 'react'
// components
import CompleteReview from 'components/Modals/PlanItems/components/CompleteReview'
// context
import ReviewsListBL from 'containers/Review/ReviewList/layers/BL/index'
import CompleteReviewBL from 'containers/Review/CompleleReview/layers/BL'
import ReviewDetailsBL from 'containers/Review/ReviewDetails/layers/BL'

const CompleteReviewContainer = props => {
  return (
    <ReviewsListBL {...props}>
      <CompleteReviewBL>
        <ReviewDetailsBL>
          <CompleteReview {...props} />
        </ReviewDetailsBL>
      </CompleteReviewBL>
    </ReviewsListBL>
  )
}
export default CompleteReviewContainer
